/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit FilterByStatus/view.blocks to change it.
import ClosedStatusFilter from './ClosedStatusFilter/index'
import OnHoldStatusFliter from './OnHoldStatusFliter/index'
import OpenStatusFilter from './OpenStatusFilter/index'
import PendingStatusFilter from './PendingStatusFilter/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function FilterByStatus({
  children,
  viewPath = "/App/Account/Content/Comms/Topbar/FilterByStatus"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="FilterByStatus.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<OpenStatusFilter
  viewPath={`${viewPath}/OpenStatusFilter`}
/>
<PendingStatusFilter
  viewPath={`${viewPath}/PendingStatusFilter`}
/>
<OnHoldStatusFliter
  viewPath={`${viewPath}/OnHoldStatusFliter`}
/>
<ClosedStatusFilter
  viewPath={`${viewPath}/ClosedStatusFilter`}
/>
</div>
{children}
</React.Fragment>)
}